export default __webpack_public_path__ + "images/ceiling-fan-1.ebd4488d8785865c3110abf72bfe65d0.png";